module.exports = __webpack_public_path__ + "img/kudos-footer.17ec94f2.png";